import { Column } from 'components/common/layout'
import { SemiBoldText } from 'components/common/text'
import { KakaoLoginBtn } from 'components/misc/login'
import React from 'react'
import { useStores } from 'stores/globals'
import styled from 'styled-components'

export const LoginOverlay: React.FCC<{ style?: React.CSSProperties }> = ({
  children,
  style,
}) => {
  const { loginStore } = useStores()
  return (
    <WhiteOverlay style={style}>
      <LoginBox>
        <LoginText>{children}</LoginText>
        <KakaoLoginBtn
          onClick={() => {
            loginStore.setIsModalOpen(true)
          }}
        />
      </LoginBox>
    </WhiteOverlay>
  )
}

const WhiteOverlay = styled(Column)`
  position: absolute;
  top: 0;
  left: -4px;
  width: calc(100% + 8px);
  height: 100%;
  background: rgba(255, 255, 255, 0.6);
  padding: 40px 4px;
  justify-content: start;
  align-items: center;
`

const LoginBox = styled(Column)`
  gap: 16px;
  @media ${(p) => p.theme.deviceSize.mobile} {
    width: 100%;
  }
`

const LoginText = styled(SemiBoldText)`
  font-size: ${(p) => p.theme.fontSize.h5};
  line-height: 1.5;
  text-align: center;
`

export const BlurLayer = styled.div<{ top?: number }>`
  position: absolute;
  top: ${(p) => (p.top ? `${p.top}px` : 0)};
  left: -4px;
  width: calc(100% + 8px);
  height: calc(100% - ${(p) => p.top || 0}px);
  backdrop-filter: blur(4px);
`
